import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import React from 'react';
import './style.scss';

interface Props {
    position: string;
    title: string;
    price: number;
    count: number;
    className: string;
    onNegativeClick: React.MouseEventHandler<SVGSVGElement> | undefined
    onPositiveClick: React.MouseEventHandler<SVGSVGElement> | undefined
}

function RenderItem(props: Props) {
  const {
    position, title, price, count, className, onPositiveClick, onNegativeClick,
  } = props;
  return (
    <div className={`d-flex justify-content-between px-4 px-xl-5 ${className}`} style={{ height: '90px' }}>
      <div className="d-flex align-items-center">
        <div className="position-container">
          {position}
        </div>
        <div className="ms-2 fz-14 d-flex flex-column justify-content-center">
          <div>{title}</div>
          <div>{price}</div>
        </div>
      </div>
      <div className="d-flex align-items-center">
        <RemoveIcon onClick={onNegativeClick} role="button" />
        <div className="counter-container mx-2">{count}</div>
        <AddIcon onClick={onPositiveClick} role="button" />
      </div>
    </div>
  );
}

export default RenderItem;
